import keyMirror from 'keymirror';

export const notificationActionTypes = keyMirror({
	CREATE_NOTIFICATION_MESSAGE: null,
	NOTIFICATION_MESSAGE_CLOSE: null,
	CLEAR_STATE: null,
});

export const DEFAULT_NOTIFICATION_TIMEOUT = 5000;
